export default (palette) => ({
  root: {
    color: palette.icon,
    minWidth: 32
  }
});
